// import { morph } from '@theme/morph';
// import { CartAddEvent } from '@theme/events';

// document.addEventListener("DOMContentLoaded", function () {
//   const starterPackManager = {
//     totalQuantity: 0,
//     productQuantities: {},
//     bagOptions: document.querySelectorAll(".bkn-starter-pack-bag-option"),
//     quantityDisplays: document.querySelectorAll(".bkn-starter-pack-quantity"),
//     addToCartBtn: document.getElementById("addToCartBtn"),
//     abortController: undefined,
//     selectedBagCount: 3, // Track the selected bag count across subscription changes

//     init() {
//       // // console.log("Starter pack manager initializing...");
//       // // console.log("Bag options found:", document.querySelectorAll(".bkn-starter-pack-bag-option").length);
//       this.bindEvents();
//       this.updateBagSelection();
//       this.updateCartButton();
//       this.initializeQuantitySelectors();
//       this.initializeSubscriptionState();
//       // // console.log("Starter pack manager initialized!");
//     },

//     /**
//      * @param {boolean} subscription
//      */
//     showPackOption(subscription) {
//       if (subscription) {
//         // Get all the pack options with the data-subscription attribute "true", set the display to block while the rest are set to none
//         this.bagOptions.forEach((option) => {
//           // // console.log(option)
//           if (option instanceof HTMLElement) {
//             if (option.getAttribute("data-subscription") === "true") {
//               option.style.display = "block";
//             } else {
//               option.style.display = "none";
//             }
//           }
//         });
//       } else {
//         // Get all the pack options with the data-subscription attribute "false", set the display to block while the rest are set to none
//         this.bagOptions.forEach((option) => {
//           if (option instanceof HTMLElement) {
//             if (option.getAttribute("data-subscription") === "false") {
//               option.style.display = "block";
//             } else {
//               option.style.display = "none";
//             }
//           }
//         });
//       }
//     },

//     /**
//      * Initialize subscription state on page load
//      */
//     initializeSubscriptionState() {
//       // Check which subscription option is selected by default
//       const subscribeRadio = document.getElementById("subscribe");
//       const oneTimeRadio = document.querySelector('input[name="purchase-type"]:not(#subscribe)');
      
//       let isSubscription = true; // Default to subscription if subscribe radio is checked
//       if (subscribeRadio && 'checked' in subscribeRadio) {
//         isSubscription = subscribeRadio.checked;
//       } else if (oneTimeRadio && 'checked' in oneTimeRadio) {
//         isSubscription = !oneTimeRadio.checked;
//       }
      
//       // Show appropriate pack options based on initial state
//       this.showPackOption(isSubscription);
//     },

//     initializeQuantitySelectors() {
//       // Initialize all products with quantity 0 and SELECT button visible
//       document.querySelectorAll("[data-product]").forEach((element) => {
//         if (element.classList.contains("bkn-starter-pack-quantity-selector")) {
//           const productId = element.getAttribute("data-product");
//           if (productId) {
//             this.productQuantities[productId] = 0;
//             this.updateQuantitySelector(productId);
//           }
//         }
//       });
//     },

//     bindEvents() {
//       // Use event delegation to handle events even after DOM morphing
//       document.addEventListener("click", (e) => {
//         // Handle quantity button clicks
//         if (e.target.classList.contains("bkn-starter-pack-qty-btn")) {
//           this.handleQuantityChange(e);
//         }
        
//         // Handle SELECT button clicks  
//         if (e.target.classList.contains("bkn-starter-pack-select-btn")) {
//           this.handleSelectClick(e);
//         }
        
//         // Handle bag option clicks
//         if (e.target.closest(".bkn-starter-pack-bag-option")) {
//           e.preventDefault();
//           // console.log("Bag option clicked:", e.target.closest(".bkn-starter-pack-bag-option"));
//           this.handleBagSelection(e);
//         }
        
//         // Handle add to cart button click
//         if (e.target.closest(".bkn-starter-pack-add-to-cart-btn")) {
//           e.preventDefault();
//           // console.log("Add to cart clicked");
//           this.handleAddToCart(e);
//         }
//       });

//       // Handle subscription radio button changes
//       document.addEventListener("change", (e) => {
//         if (e.target.name === "purchase-type") {
//           this.handleSubscriptionChange(e);
//         }
//       });
//     },

//     /**
//      * Handle subscription radio button changes
//      * @param {Event} e
//      */
//     handleSubscriptionChange(e) {
//       const isSubscription = e.target.id === "subscribe";
//       // console.log("Subscription changed:", isSubscription);
      
//       // Store the currently selected bag count before switching
//       const currentlyActive = document.querySelector('.bkn-starter-pack-bag-option.bkn-starter-pack-active');
//       if (currentlyActive) {
//         this.selectedBagCount = parseInt(currentlyActive.getAttribute("data-bag-count"));
//       }
      
//       // Show appropriate pack options
//       this.showPackOption(isSubscription);
      
//       // Find and select the corresponding bag option with the same bag count
//       this.selectBagOptionByCount(this.selectedBagCount, isSubscription);
//     },

//     /**
//      * Select bag option by count and subscription type
//      * @param {number} bagCount
//      * @param {boolean} isSubscription
//      */
//     selectBagOptionByCount(bagCount, isSubscription) {
//       const targetSubscription = isSubscription ? "true" : "false";
//       const targetOption = document.querySelector(
//         `[data-bag-count="${bagCount}"][data-subscription="${targetSubscription}"]`
//       );
      
//       if (targetOption) {
//         // Remove active from all options
//         document.querySelectorAll(".bkn-starter-pack-bag-option").forEach((option) => {
//           option.classList.remove("bkn-starter-pack-active");
//         });
        
//         // Add active to target option
//         targetOption.classList.add("bkn-starter-pack-active");
        
//         // Update URL and fetch new data
//         const variantId = targetOption.getAttribute("data-variant-id");
//         if (variantId) {
//           const url = new URL(window.location.href);
//           url.searchParams.set("variant", variantId);
//           window.history.replaceState({}, "", url.toString());
          
//           this.dispatchVariantSelectedEvent(variantId, {
//             bagCount,
//             subscription: targetSubscription,
//             element: targetOption
//           });
          
//           this.fetchUpdatedSection(this.buildRequestUrl(variantId));
//         }
        
//         // Update cart button
//         this.updateCartButton();
//       } else {
//         console.warn(`No bag option found for count ${bagCount} and subscription ${targetSubscription}`);
//       }
//     },

//     handleSelectClick(e) {
//       const button = e.target;
//       const productId = button.getAttribute("data-product");

//       if (this.totalQuantity >= 7) {
//         return; // Don't allow adding more
//       }

//       // Set quantity to 1 and update display
//       this.productQuantities[productId] = 1;
//       this.updateQuantitySelector(productId);

//       this.calculateTotalQuantity();
//       this.updateBagSelection();
//       this.updateCartButton();
//     },

//     updateQuantitySelector(productId) {
//       const selector = document.querySelector(
//         `[data-product="${productId}"].bkn-starter-pack-quantity-selector`
//       );
//       if (!selector) return;

//       const qtyControls = selector.querySelector(
//         ".bkn-starter-pack-qty-controls"
//       );
//       const selectBtn = selector.querySelector(".bkn-starter-pack-select-btn");
//       const quantityDisplay = selector.querySelector(
//         ".bkn-starter-pack-quantity"
//       );

//       const quantity = this.productQuantities[productId] || 0;

//       if (quantity === 0) {
//         // Show SELECT button, hide quantity controls
//         if (qtyControls && qtyControls instanceof HTMLElement) {
//           qtyControls.style.display = "none";
//         }
//         if (selectBtn && selectBtn instanceof HTMLElement) {
//           selectBtn.style.display = "flex";
//           if ('disabled' in selectBtn) {
//             selectBtn.disabled = this.totalQuantity >= 7;
//           }
//           selectBtn.style.opacity = this.totalQuantity >= 7 ? "0.5" : "1";
//         }
//       } else {
//         // Show quantity controls, hide SELECT button
//         if (qtyControls && qtyControls instanceof HTMLElement) {
//           qtyControls.style.display = "flex";
//         }
//         if (selectBtn && selectBtn instanceof HTMLElement) {
//           selectBtn.style.display = "none";
//         }
//         if (quantityDisplay) {
//           quantityDisplay.textContent = quantity.toString();
//         }
//         const plusBtn = selector.querySelector(".bkn-starter-pack-plus");
//         if (plusBtn && plusBtn instanceof HTMLElement && 'disabled' in plusBtn) {
//           plusBtn.disabled = this.totalQuantity >= 7;
//           plusBtn.style.opacity = this.totalQuantity >= 7 ? "0.3" : "1";
//         }
//       }
//     },

//     handleQuantityChange(e) {
//       const button = e.target;
//       const action = button.getAttribute("data-action");
//       const productId = button.getAttribute("data-product");

//       let currentQty = this.productQuantities[productId] || 0;

//       if (action === "increase") {
//         if (this.totalQuantity >= 7) {
//           return; // Don't allow adding more
//         }
//         currentQty++;
//       } else if (action === "decrease" && currentQty > 0) {
//         currentQty--;
//       }

//       // Update internal tracking
//       this.productQuantities[productId] = currentQty;

//       // Update the quantity selector display
//       this.updateQuantitySelector(productId);

//       this.calculateTotalQuantity();
//       this.updateBagSelection();
//       this.updateCartButton();
//     },

//     calculateTotalQuantity() {
//       this.totalQuantity = Object.values(this.productQuantities).reduce(
//         (sum, qty) => sum + qty,
//         0
//       );

//       // Update all quantity selectors to reflect the new total (for button states)
//       Object.keys(this.productQuantities).forEach((productId) => {
//         this.updateQuantitySelector(productId);
//       });

//       // Update debug display if visible
//       const debugTotal = document.getElementById("totalQuantity");
//       if (debugTotal) {
//         debugTotal.textContent = this.totalQuantity;
//       }
//     },

//     updateBagSelection() {
//       let selectedBagCount = 3; // default

//       if (this.totalQuantity <= 3) {
//         selectedBagCount = 3;
//       } else if (this.totalQuantity <= 5) {
//         selectedBagCount = 5;
//       } else {
//         selectedBagCount = 7;
//       }

//       // Update the tracked selected bag count
//       this.selectedBagCount = selectedBagCount;

//       // Determine current subscription type from radio buttons
//       const subscribeRadio = document.getElementById("subscribe");
//       const isSubscription = subscribeRadio && 'checked' in subscribeRadio && subscribeRadio.checked;
//       const subscriptionValue = isSubscription ? "true" : "false";

//       // Remove active class from all options
//       this.bagOptions.forEach((option) => {
//         option.classList.remove("bkn-starter-pack-active");
//       });

//       // Add active class to selected option with correct subscription type
//       const selectedOption = document.querySelector(
//         `[data-bag-count="${selectedBagCount}"][data-subscription="${subscriptionValue}"]`
//       );
//       if (selectedOption) {
//         selectedOption.classList.add("bkn-starter-pack-active");
        
//         // Update URL and fetch new data if variant changed
//         const variantId = selectedOption.getAttribute("data-variant-id");
//         if (variantId) {
//           const currentUrl = new URL(window.location.href);
//           const currentVariant = currentUrl.searchParams.get("variant");
          
//           // Only update if variant actually changed
//           if (currentVariant !== variantId) {
//             currentUrl.searchParams.set("variant", variantId);
//             window.history.replaceState({}, "", currentUrl.toString());
            
//             this.dispatchVariantSelectedEvent(variantId, {
//               bagCount: selectedBagCount,
//               subscription: subscriptionValue,
//               element: selectedOption
//             });
            
//             this.fetchUpdatedSection(this.buildRequestUrl(variantId));
//           }
//         }
//       } else {
//         console.warn(`No bag option found for count ${selectedBagCount} and subscription ${subscriptionValue}`);
//       }

//       // Update debug display if visible
//       const debugBag = document.getElementById("selectedBag");
//       if (debugBag) {
//         debugBag.textContent = `${selectedBagCount} bags`;
//       }
//     },

//     handleBagSelection(e) {
//       const clickedOption = e.target.closest(".bkn-starter-pack-bag-option");
//       if (!clickedOption) {
//         // console.log("No bag option found");
//         return;
//       }
      
//       const bagCount = parseInt(clickedOption.getAttribute("data-bag-count"));
//       const subscription = clickedOption.getAttribute("data-subscription");
//       const variantId = clickedOption.getAttribute("data-variant-id");
      
//       // Update the selected bag count
//       this.selectedBagCount = bagCount;
      
//       console.log("Bag selection:", { bagCount, subscription, variantId });

//       // Remove active from all (use fresh query to handle DOM changes)
//       document.querySelectorAll(".bkn-starter-pack-bag-option").forEach((option) => {
//         option.classList.remove("bkn-starter-pack-active");
//       });

//       // Add active to clicked
//       clickedOption.classList.add("bkn-starter-pack-active");

//       // Update the URL with the new variant ID (similar to variant-picker.js)
//       const url = new URL(window.location.href);
//       url.searchParams.set("variant", variantId);
      
//       // Update browser history without page reload
//       window.history.replaceState({}, "", url.toString());

//       // Dispatch variant selected event (similar to variant-picker.js)
//       this.dispatchVariantSelectedEvent(variantId, {
//         bagCount,
//         subscription,
//         element: clickedOption
//       });

//       // Fetch updated section information (similar to variant-picker.js)
//       this.fetchUpdatedSection(this.buildRequestUrl(variantId));

//       // Optional: Adjust quantities to match bag selection
//       this.adjustQuantitiesToBag(bagCount);
//     },

//     adjustQuantitiesToBag(targetBagCount) {
//       const currentTotal = this.totalQuantity;

//       if (currentTotal === 0) {
//         // If no products selected, don't auto-fill
//         return;
//       }

//       if (currentTotal < targetBagCount) {
//         // Add quantities to reach target
//         const difference = targetBagCount - currentTotal;
//         const productIds = Object.keys(this.productQuantities);

//         if (productIds.length > 0) {
//           // Distribute the difference across existing products
//           let remaining = difference;
//           productIds.forEach((productId) => {
//             if (remaining > 0 && this.productQuantities[productId] && this.productQuantities[productId] > 0) {
//               this.productQuantities[productId]++;
//               remaining--;

//               // Update the quantity selector display
//               this.updateQuantitySelector(productId);
//             }
//           });
//         }
//       }

//       this.calculateTotalQuantity();
//       this.updateCartButton();
//     },

//     updateCartButton() {
//       const cartButtonText = document.getElementById("cartButtonText");
      
//       // Get price from selected bag option
//       const bagPrice = this.getSelectedBagPrice();
      
//       // Disable button if totalQuantity is 0, 1, 2, 4, or 6
//       const invalidQuantities = [0, 1, 2, 4, 6];
//       const shouldDisable = invalidQuantities.includes(this.totalQuantity);
      
//       if (shouldDisable) {
//         if (this.addToCartBtn && 'disabled' in this.addToCartBtn) {
//           this.addToCartBtn.disabled = true;
//         }
//         if (this.addToCartBtn && this.addToCartBtn instanceof HTMLElement) {
//           this.addToCartBtn.style.opacity = "0.6";
//         }
//         if (cartButtonText) {
//           cartButtonText.textContent = `Add to Cart • ${bagPrice}`;
//         }
//       } else {
//         if (this.addToCartBtn && 'disabled' in this.addToCartBtn) {
//           this.addToCartBtn.disabled = false;
//         }
//         if (this.addToCartBtn && this.addToCartBtn instanceof HTMLElement) {
//           this.addToCartBtn.style.opacity = "1";
//         }
//         if (cartButtonText) {
//           cartButtonText.textContent = `Add to Cart • ${bagPrice}`;
//         }
//       }
//     },

//     /**
//      * Get the price from the currently selected bag option
//      * @returns {string} Formatted price string
//      */
//     getSelectedBagPrice() {
//       const activeBagOption = document.querySelector('.bkn-starter-pack-bag-option.bkn-starter-pack-active');
//       if (activeBagOption) {
//         const priceText = activeBagOption.getAttribute('data-price');
//         if (priceText) {
//           return priceText;
//         }
//       }
      
//       // Fallback to first visible bag option
//       const firstVisibleBagOption = document.querySelector('.bkn-starter-pack-bag-option[style*="block"], .bkn-starter-pack-bag-option:not([style*="none"])');
//       if (firstVisibleBagOption) {
//         const priceText = firstVisibleBagOption.getAttribute('data-price');
//         if (priceText) {
//           return priceText;
//         }
//       }
      
//       return '$25.99'; // Fallback price
//     },

//     calculatePrice(basePriceText = null) {
//       // Get base price from current selected variant or use provided price
//       let basePrice;
//       if (basePriceText) {
//         // Extract numeric value from price text (e.g., "$25.99" -> 25.99)
//         basePrice = parseFloat(basePriceText.replace(/[^0-9.-]+/g, ''));
//       } else {
//         // Get price from currently selected bag option
//         const activeBagOption = document.querySelector('.bkn-starter-pack-bag-option.bkn-starter-pack-active');
//         if (activeBagOption) {
//           const priceText = activeBagOption.getAttribute('data-price');
//           basePrice = priceText ? parseFloat(priceText.replace(/[^0-9.-]+/g, '')) : 0;
//         } else {
//           // Fallback to first bag option
//           const firstBagOption = document.querySelector('.bkn-starter-pack-bag-option');
//           if (firstBagOption) {
//             const priceText = firstBagOption.getAttribute('data-price');
//             basePrice = priceText ? parseFloat(priceText.replace(/[^0-9.-]+/g, '')) : 0;
//           } else {
//             basePrice = 0;
//           }
//         }
//       }

//       if (!basePrice || basePrice <= 0) {
//         console.warn('Could not determine base price, using fallback');
//         basePrice = 25.99; // Fallback price
//       }

//       let discount = 0;

//       // Apply bag discounts based on total quantity
//       if (this.totalQuantity >= 7) {
//         discount = 0.1; // 10% off
//       } else if (this.totalQuantity >= 5) {
//         discount = 0.05; // 5% off
//       }

//       // Apply subscription discount if selected
//       const subscribeRadio = document.getElementById("subscribe");
//       if (subscribeRadio && 'checked' in subscribeRadio && subscribeRadio.checked) {
//         discount += 0.15; // Additional 15% for subscription
//       }

//       const finalPrice = basePrice * (1 - discount);
//       // console.log('Price calculation:', { basePrice, discount, finalPrice, totalQuantity: this.totalQuantity });
      
//       return finalPrice; // Return per-unit price, not total
//     },


//     // Dispatch variant selected event (similar to variant-picker.js)
//     dispatchVariantSelectedEvent(variantId, additionalData = {}) {
//       // Create a custom event similar to VariantSelectedEvent in variant-picker.js
//       const variantSelectedEvent = new CustomEvent('variant:selected', {
//         detail: {
//           variantId: variantId,
//           ...additionalData
//         },
//         bubbles: true
//       });

//       // Dispatch from the container element
//       const container = document.querySelector('.bkn-starter-pack-container');
//       if (container) {
//         container.dispatchEvent(variantSelectedEvent);
//       }

//       // Also dispatch a generic change event that other components might listen for
//       const changeEvent = new CustomEvent('starter-pack:variant-changed', {
//         detail: {
//           variantId: variantId,
//           ...additionalData
//         },
//         bubbles: true
//       });
      
//       document.dispatchEvent(changeEvent);
//     },

//     // Build request URL for fetching updated section (similar to variant-picker.js)
//     buildRequestUrl(variantId) {
//       const currentUrl = window.location.pathname;
//       const params = [`variant=${variantId}`];
      
//       // For starter pack, we need to get the entire product page with the new variant
//       return `${currentUrl}?${params.join('&')}`;
//     },

//     // Fetch updated section (similar to variant-picker.js)
//     fetchUpdatedSection(requestUrl) {
//       // Abort any pending request
//       if (this.abortController) {
//         this.abortController.abort();
//       }
//       this.abortController = new AbortController();

//       fetch(requestUrl, { signal: this.abortController.signal })
//         .then((response) => response.text())
//         .then((responseText) => {
//           const html = new DOMParser().parseFromString(responseText, 'text/html');
          
//           // Update the starter pack section with new variant data
//           this.updateStarterPackSection(html);
          
//           // Dispatch variant update event
//           const variantUpdateEvent = new CustomEvent('variant:updated', {
//             detail: {
//               variantId: requestUrl.match(/variant=(\d+)/)?.[1],
//               html: html
//             },
//             bubbles: true
//           });
          
//           document.dispatchEvent(variantUpdateEvent);
//         })
//         .catch((error) => {
//           if (error.name === 'AbortError') {
//             console.warn('Fetch aborted by user');
//           } else {
//             console.error('Error fetching updated section:', error);
//           }
//         });
//     },

//     // Update the starter pack section with new data
//     updateStarterPackSection(newHtml) {
//       try {
//         // Instead of morphing the entire section, update specific elements to preserve events
//         this.updateSpecificElements(newHtml);
//       } catch (error) {
//         console.warn('Could not update starter pack section:', error);
//       }
//     },


//     // Fallback method to update specific elements
//     updateSpecificElements(newHtml) {
//       try {
//         // Update bag options with new pricing data first
//         const newBagOptions = newHtml.querySelectorAll('.bkn-starter-pack-bag-option');
//         const currentBagOptions = document.querySelectorAll('.bkn-starter-pack-bag-option');
        
//         newBagOptions.forEach((newOption, index) => {
//           if (currentBagOptions[index]) {
//             const newPrice = newOption.getAttribute('data-price');
//             const newVariantId = newOption.getAttribute('data-variant-id');
//             const newBagCount = newOption.getAttribute('data-bag-count');
//             const newSubscription = newOption.getAttribute('data-subscription');
            
//             if (newPrice) {
//               currentBagOptions[index].setAttribute('data-price', newPrice);
//               //  console.log(`Updated bag option ${index} price to:`, newPrice);
//             }
//             if (newVariantId) {
//               currentBagOptions[index].setAttribute('data-variant-id', newVariantId);
//             }
//             if (newBagCount) {
//               currentBagOptions[index].setAttribute('data-bag-count', newBagCount);
//             }
//             if (newSubscription) {
//               currentBagOptions[index].setAttribute('data-subscription', newSubscription);
//             }
//           }
//         });

//         // Update product information if available
//         const newProductInfo = newHtml.querySelector('.bkn-starter-pack-product-grid');
//         const currentProductInfo = document.querySelector('.bkn-starter-pack-product-grid');
//         if (newProductInfo && currentProductInfo) {
//           // Update product images, names, or other variant-specific content
//           const newImages = newProductInfo.querySelectorAll('.bkn-starter-pack-product-img');
//           const currentImages = currentProductInfo.querySelectorAll('.bkn-starter-pack-product-img');
          
//           newImages.forEach((newImg, index) => {
//             if (currentImages[index]) {
//               currentImages[index].src = newImg.src;
//               currentImages[index].alt = newImg.alt;
//             }
//           });
//         }

//         // update ATC button price
//         const atcButtonPrice = newHtml.querySelector('#cartPrice');
//         const currentAtcButtonPrice = document.querySelector('#cartPrice');
//         if (atcButtonPrice && currentAtcButtonPrice) {
//           currentAtcButtonPrice.textContent = atcButtonPrice.textContent;
//         }

//         // Update cart button with new pricing - this will now get the updated data-price values
//         this.updateCartButton();

//         // console.log('Successfully updated variant-specific elements');

//       } catch (error) {
//         console.warn('Could not update specific elements:', error);
//       }
//     },

//     // Handle add to cart functionality
//     handleAddToCart(e) {
//       if (this.totalQuantity === 0) {
//         console.warn('No products selected');
//         return;
//       }

//       // Get selected variant information
//       const activeBagOption = document.querySelector('.bkn-starter-pack-bag-option.bkn-starter-pack-active');
//       if (!activeBagOption) {
//         console.error('No bag option selected');
//         return;
//       }

//       const variantId = activeBagOption.getAttribute('data-variant-id');
//       if (!variantId) {
//         console.error('No variant ID found');
//         return;
//       }

//       // Collect selected flavors
//       const selectedFlavors = this.getSelectedFlavors();
//       // console.log('Selected flavors:', selectedFlavors);

//       // Check if subscription is selected
//       const subscribeRadio = document.getElementById("subscribe");
//       const isSubscription = subscribeRadio && 'checked' in subscribeRadio && subscribeRadio.checked;

//       // Prepare cart data with formatted flavors and hidden metadata
//       const cartData = {
//         items: [{
//           id: variantId,
//           quantity: 1, // Always 1 for starter pack
//           properties: {
//             // Display the flavors in the desired format
//             ...selectedFlavors.reduce((acc, flavor, index) => {
//               acc[`flavor_${index + 1}`] = flavor;
//               return acc;
//             }, {}),
//             // Hidden metadata properties (prefixed with underscore)
//             '_total_items': this.totalQuantity,
//             '_bag_type': activeBagOption.querySelector('.bkn-starter-pack-bag-count')?.textContent || '',
//             '_purchase_type': isSubscription ? 'subscription' : 'one-time'
//           }
//         }]
//       };

//       // console.log('Adding to cart:', cartData);

//       // Add to cart
//       this.addToCart(cartData);
//     },

//     // Get selected flavors from the product grid formatted as qty x flavor
//     getSelectedFlavors() {
//       const flavorCounts = {};
      
//       // Loop through all products and check their quantities
//       Object.keys(this.productQuantities).forEach(productId => {
//         const quantity = this.productQuantities[productId];
//         if (quantity > 0) {
//           // Find the product name
//           const productCard = document.querySelector(`[data-product="${productId}"]`);
//           if (productCard) {
//             const productNameElement = productCard.closest('.bkn-starter-pack-product-card')?.querySelector('.bkn-starter-pack-product-name');
//             if (productNameElement) {
//               const productName = productNameElement.textContent.trim();
//               flavorCounts[productName] = quantity;
//             }
//           }
//         }
//       });

//       // Format as "qty x flavor" lines
//       const formattedFlavors = Object.entries(flavorCounts).map(([flavor, qty]) => {
//         return `${qty}x ${flavor}`;
//       });

//       return formattedFlavors;
//     },

//     // Add items to cart using Shopify Cart API
//     addToCart(cartData) {
//       // Disable the add to cart button during the request
//       const addToCartBtn = document.getElementById("addToCartBtn");
//       const cartButtonText = document.getElementById("cartButtonText");
      
//       if (addToCartBtn && 'disabled' in addToCartBtn) {
//         addToCartBtn.disabled = true;
//       }
//       if (cartButtonText) {
//         cartButtonText.textContent = "ADDING TO CART...";
//       }

//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(cartData)
//       })
//       .then(response => {
//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }
//         return response.json();
//       })
//       .then(data => {
//         // console.log('Successfully added to cart:', data);
        
//         // Show success message
//         this.showAddToCartSuccess();
        
//         // Update cart drawer or redirect to cart
//         this.handleAddToCartSuccess(data);
//       })
//       .catch(error => {
//         console.error('Error adding to cart:', error);
//         this.showAddToCartError(error);
//       })
//       .finally(() => {
//         // Re-enable the add to cart button
//         if (addToCartBtn && 'disabled' in addToCartBtn) {
//           addToCartBtn.disabled = false;
//         }
//         if (cartButtonText) {
//           const bagPrice = this.getSelectedBagPrice();
//           cartButtonText.textContent = `Add to Cart • ${bagPrice}`;
//         }
//       });
//     },

//     // Show success message after adding to cart
//     showAddToCartSuccess() {
//       const cartButtonText = document.getElementById("cartButtonText");
//       if (cartButtonText) {
//         cartButtonText.textContent = "ADDED TO CART!";
        
//         // Reset after 2 seconds
//         setTimeout(() => {
//           const bagPrice = this.getSelectedBagPrice();
//           cartButtonText.textContent = `Add to Cart • ${bagPrice}`;
//         }, 2000);
//       }
//     },

//     // Handle successful add to cart
//     handleAddToCartSuccess(cartResponse) {
//       // Get the active bag option to get variant info
//       const activeBagOption = document.querySelector('.bkn-starter-pack-bag-option.bkn-starter-pack-active');
//       const variantId = activeBagOption?.getAttribute('data-variant-id');

//       // Dispatch the proper CartAddEvent that the cart drawer listens for
//       const cartAddEvent = new CartAddEvent(
//         {}, // Empty object like other components use
//         variantId || 'starter-pack', // Use variant ID as source ID
//         {
//           source: 'starter-pack',
//           variantId: variantId,
//           itemCount: cartResponse.item_count || 1,
//           productId: variantId // Add product ID for compatibility
//         }
//       );
      
//       document.dispatchEvent(cartAddEvent);

//       // Also dispatch custom event for other components to listen to
//       const starterPackEvent = new CustomEvent('starter-pack:added-to-cart', {
//         detail: {
//           flavors: this.getSelectedFlavors(),
//           totalQuantity: this.totalQuantity
//         },
//         bubbles: true
//       });
      
//       document.dispatchEvent(starterPackEvent);

//       // The CartAddEvent should trigger the cart drawer's built-in refresh mechanism
//       // No need to manually reload - let the cart drawer handle its own updates

//       // Try to open cart drawer if it exists
//       const cartDrawerComponent = document.querySelector('cart-drawer-component');
//       // console.log('Cart drawer component found:', cartDrawerComponent);
      
//       if (cartDrawerComponent && typeof cartDrawerComponent.open === 'function') {
//         // console.log('Opening cart drawer via cart-drawer-component');
//         cartDrawerComponent.open();
//       } else {
//         // Fallback: look for other cart drawer selectors
//         const cartDrawer = document.querySelector('cart-drawer');
//         // console.log('Fallback cart drawer found:', cartDrawer);
        
//         if (cartDrawer && typeof cartDrawer.open === 'function') {
//           // console.log('Opening cart drawer via cart-drawer');
//           cartDrawer.open();
//         } else {
//           console.warn('No cart drawer found or open method not available');
//           // Try clicking the cart icon as a last resort
//           const cartIcon = document.querySelector('[aria-label*="cart"]') || 
//                           document.querySelector('.cart-icon') ||
//                           document.querySelector('[data-cart-icon]');
//           if (cartIcon) {
//             // console.log('Clicking cart icon as fallback');
//             cartIcon.click();
//           }
//         }
//       }
//     },

//     // Note: Removed reloadCartDrawer method as it was breaking cart drawer functionality
//     // The CartAddEvent should handle cart drawer updates automatically

//     // Update cart count in header/icon
//     updateCartCount() {
//       fetch('/cart.js')
//         .then(response => response.json())
//         .then(cart => {
//           const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count]');
//           cartCountElements.forEach(element => {
//             element.textContent = cart.item_count;
//             // Also update any data attributes
//             element.setAttribute('data-cart-count', cart.item_count);
//           });
//         })
//         .catch(error => console.warn('Could not update cart count:', error));
//     },

//     // Show error message if add to cart fails
//     showAddToCartError(error) {
//       const cartButtonText = document.getElementById("cartButtonText");
//       if (cartButtonText) {
//         cartButtonText.textContent = "ERROR - TRY AGAIN";
        
//         // Reset after 3 seconds
//         setTimeout(() => {
//           const bagPrice = this.getSelectedBagPrice();
//           cartButtonText.textContent = `Add to Cart • ${bagPrice}`;
//         }, 3000);
//       }
      
//       // You could also show a toast notification or modal here
//       console.error('Add to cart failed:', error);
//     }
//   };



//   // Initialize the starter pack manager
//   starterPackManager.init();
// });


import { morph } from '@theme/morph';
import { CartAddEvent } from '@theme/events';

document.addEventListener("DOMContentLoaded", function () {
  const starterPackManager = {
    totalQuantity: 0,
    productQuantities: {},
    bagOptions: document.querySelectorAll(".bkn-starter-pack-bag-option"),
    quantityDisplays: document.querySelectorAll(".bkn-starter-pack-quantity"),
    addToCartBtn: document.getElementById("addToCartBtn"),
    abortController: undefined,
    selectedBagCount: 3,
    currentVariant: null,
    variantCheckInterval: null,

    init() {
      this.bindEvents();
      this.initializeQuantitySelectors();
      this.initializeSubscriptionState();
      this.loadPersistedVariant();
      this.initializeFromUrlVariant();
      this.updateBagSelection();
      this.updateCartButton();
      this.watchVariantChanges();
    },

    loadPersistedVariant() {
      const stored = sessionStorage.getItem('bkn-starter-pack-variant');
      if (stored) {
        const { variantId, bagCount, subscription } = JSON.parse(stored);
        const option = document.querySelector(
          `.bkn-starter-pack-bag-option[data-variant-id="${variantId}"]`
        );
        
        if (option && window.getComputedStyle(option).display !== 'none') {
          this.selectedBagCount = bagCount;
          this.setActiveOption(option);
          this.updatePriceFromActiveOption();
        }
      }
    },

    persistVariant(variantId, bagCount, subscription) {
      sessionStorage.setItem('bkn-starter-pack-variant', JSON.stringify({
        variantId,
        bagCount,
        subscription
      }));
    },

    initializeFromUrlVariant() {
      const variantId = this.getVariantFromUrl();
      
      if (variantId) {
        const matchingOption = document.querySelector(
          `.bkn-starter-pack-bag-option[data-variant-id="${variantId}"]`
        );

        if (matchingOption && window.getComputedStyle(matchingOption).display !== 'none') {
          const bagCount = parseInt(matchingOption.getAttribute('data-bag-count'));
          this.selectedBagCount = bagCount;
          this.setActiveOption(matchingOption);
          this.updatePriceFromActiveOption();
          this.persistVariant(variantId, bagCount, matchingOption.getAttribute('data-subscription'));
        }
      }
    },

    setActiveOption(option) {
      document.querySelectorAll('.bkn-starter-pack-bag-option').forEach(o => {
        o.classList.remove('bkn-starter-pack-active');
      });
      option.classList.add('bkn-starter-pack-active');
    },

    updatePriceFromActiveOption() {
      const activeOption = document.querySelector('.bkn-starter-pack-bag-option.bkn-starter-pack-active');
      if (!activeOption) return;

      const price = activeOption.getAttribute('data-price');
      const comparePrice = activeOption.getAttribute('data-compare-price');

      const elements = {
        cartPrice: document.getElementById('cartPrice'),
        cartComparePrice: document.getElementById('cartComparePrice'),
        cartPriceBtn: document.getElementById('cartPriceBtn'),
        cartComparePriceBtn: document.getElementById('cartComparePriceBtn')
      };

      if (elements.cartPrice) elements.cartPrice.textContent = price;
      if (elements.cartPriceBtn) elements.cartPriceBtn.textContent = price;

      if (comparePrice) {
        if (elements.cartComparePrice) {
          elements.cartComparePrice.textContent = comparePrice;
          elements.cartComparePrice.style.display = 'inline';
        }
        if (elements.cartComparePriceBtn) {
          elements.cartComparePriceBtn.textContent = comparePrice;
          elements.cartComparePriceBtn.style.display = 'inline';
        }
      } else {
        if (elements.cartComparePrice) elements.cartComparePrice.style.display = 'none';
        if (elements.cartComparePriceBtn) elements.cartComparePriceBtn.style.display = 'none';
      }
    },

    watchVariantChanges() {
      this.currentVariant = this.getVariantFromUrl();
      
      const checkVariant = () => {
        const newVariant = this.getVariantFromUrl();
        if (newVariant && newVariant !== this.currentVariant) {
          this.currentVariant = newVariant;
          this.handleVariantUrlChange(newVariant);
        }
      };

      window.addEventListener('popstate', checkVariant);
      this.variantCheckInterval = setInterval(checkVariant, 500);
    },

    getVariantFromUrl() {
      const url = new URL(window.location.href);
      return url.searchParams.get('variant');
    },

    handleVariantUrlChange(variantId) {
      if (!variantId) return;

      const matchingOption = document.querySelector(
        `.bkn-starter-pack-bag-option[data-variant-id="${variantId}"]`
      );

      if (matchingOption && window.getComputedStyle(matchingOption).display !== 'none') {
        const bagCount = parseInt(matchingOption.getAttribute('data-bag-count'));
        const subscription = matchingOption.getAttribute('data-subscription');
        
        this.selectedBagCount = bagCount;
        this.setActiveOption(matchingOption);
        this.updatePriceFromActiveOption();
        this.persistVariant(variantId, bagCount, subscription);
      }
    },

    showPackOption(subscription) {
      this.bagOptions.forEach((option) => {
        if (option instanceof HTMLElement) {
          const optionSub = option.getAttribute("data-subscription");
          option.style.display = (subscription && optionSub === "true") || (!subscription && optionSub === "false") ? "block" : "none";
        }
      });
    },

    // initializeSubscriptionState() {
    //   const subscribeRadio = document.getElementById("subscribe");
    //   let isSubscription = true;
    //   if (subscribeRadio && 'checked' in subscribeRadio) {
    //     isSubscription = subscribeRadio.checked;
    //   }
    //   this.showPackOption(isSubscription);
    // },

    initializeSubscriptionState() {
      const subscribeRadio = document.getElementById("subscribe");
      const oneTimeRadio = document.getElementById("one-time");
      
      // Set one-time as default
      let isSubscription = false;
      
      if (oneTimeRadio && 'checked' in oneTimeRadio) {
        oneTimeRadio.checked = true;
      }
      if (subscribeRadio && 'checked' in subscribeRadio) {
        subscribeRadio.checked = false;
      }
      
      this.showPackOption(isSubscription);
      this.updateSubscriptionVisualState(isSubscription);
    },

    // Add this new method to handle visual state updates
    updateSubscriptionVisualState(isSubscription) {
      const leftSection = document.querySelector('.bkn-starter-pack-left-section');
      const rightSection = document.querySelector('.bkn-starter-pack-right-section');
      const subscribeBenefits = document.querySelector('.bkn-starter-pack-subscribe-benefits');
      const subscribeFooter = document.querySelector('.bkn-starter-pack-subscribe-footer');
      const onetimeBenefits = document.querySelector('.bkn-starter-pack-onetime-benefits');
      const onetimeFooter = document.querySelector('.bkn-starter-pack-onetime-footer');
      
      if (isSubscription) {
        // Subscribe is selected
        if (leftSection) leftSection.classList.remove('bkn-starter-pack-not-selected');
        if (rightSection) rightSection.classList.add('bkn-starter-pack-not-selected');
        if (subscribeBenefits) subscribeBenefits.style.display = 'flex';
        if (subscribeFooter) subscribeFooter.style.display = 'block';
        if (onetimeBenefits) onetimeBenefits.style.display = 'none';
        if (onetimeFooter) onetimeFooter.style.display = 'none';
      } else {
        // One-time is selected
        if (leftSection) leftSection.classList.add('bkn-starter-pack-not-selected');
        if (rightSection) rightSection.classList.remove('bkn-starter-pack-not-selected');
        if (subscribeBenefits) subscribeBenefits.style.display = 'none';
        if (subscribeFooter) subscribeFooter.style.display = 'none';
        if (onetimeBenefits) onetimeBenefits.style.display = 'flex';
        if (onetimeFooter) onetimeFooter.style.display = 'block';
      }
    },

    initializeQuantitySelectors() {
      document.querySelectorAll("[data-product]").forEach((element) => {
        if (element.classList.contains("bkn-starter-pack-quantity-selector")) {
          const productId = element.getAttribute("data-product");
          if (productId) {
            this.productQuantities[productId] = 0;
            this.updateQuantitySelector(productId);
          }
        }
      });
    },

    bindEvents() {
      document.addEventListener("click", (e) => {
        if (e.target.classList.contains("bkn-starter-pack-qty-btn")) {
          this.handleQuantityChange(e);
        }
        
        if (e.target.classList.contains("bkn-starter-pack-select-btn")) {
          this.handleSelectClick(e);
        }
        
        if (e.target.closest(".bkn-starter-pack-bag-option")) {
          e.preventDefault();
          this.handleBagSelection(e);
        }
        
        if (e.target.closest(".bkn-starter-pack-add-to-cart-btn")) {
          e.preventDefault();
          this.handleAddToCart(e);
        }
      });

      document.addEventListener("change", (e) => {
        if (e.target.name === "purchase-type") {
          this.handleSubscriptionChange(e);
        }
      });
    },

    handleSubscriptionChange(e) {
      const isSubscription = e.target.id === "subscribe";
      
      const currentlyActive = document.querySelector('.bkn-starter-pack-bag-option.bkn-starter-pack-active');
      if (currentlyActive) {
        this.selectedBagCount = parseInt(currentlyActive.getAttribute("data-bag-count"));
      }
      
      this.showPackOption(isSubscription);
      this.updateSubscriptionVisualState(isSubscription);
      this.selectBagOptionByCount(this.selectedBagCount, isSubscription);

    },

    selectBagOptionByCount(bagCount, isSubscription) {
      const targetSubscription = isSubscription ? "true" : "false";
      const targetOption = document.querySelector(
        `[data-bag-count="${bagCount}"][data-subscription="${targetSubscription}"]`
      );
      
      if (targetOption) {
        this.setActiveOption(targetOption);
        
        const variantId = targetOption.getAttribute("data-variant-id");
        if (variantId) {
          const url = new URL(window.location.href);
          url.searchParams.set("variant", variantId);
          window.history.replaceState({}, "", url.toString());
          
          this.persistVariant(variantId, bagCount, targetSubscription);
          this.updatePriceFromActiveOption();
          this.dispatchVariantSelectedEvent(variantId, { bagCount, subscription: targetSubscription, element: targetOption });
        }
        
        this.updateCartButton();
      }
    },

    handleSelectClick(e) {
      const button = e.target;
      const productId = button.getAttribute("data-product");

      if (this.totalQuantity >= 7) return;

      this.productQuantities[productId] = 1;
      this.updateQuantitySelector(productId);
      this.calculateTotalQuantity();
      this.updateBagSelection();
      this.updateCartButton();
    },

    updateQuantitySelector(productId) {
      const selector = document.querySelector(
        `[data-product="${productId}"].bkn-starter-pack-quantity-selector`
      );
      if (!selector) return;

      const qtyControls = selector.querySelector(".bkn-starter-pack-qty-controls");
      const selectBtn = selector.querySelector(".bkn-starter-pack-select-btn");
      const quantityDisplay = selector.querySelector(".bkn-starter-pack-quantity");

      const quantity = this.productQuantities[productId] || 0;

      if (quantity === 0) {
        if (qtyControls) qtyControls.style.display = "none";
        if (selectBtn) {
          selectBtn.style.display = "flex";
          if ('disabled' in selectBtn) selectBtn.disabled = this.totalQuantity >= 7;
          selectBtn.style.opacity = this.totalQuantity >= 7 ? "0.5" : "1";
        }
      } else {
        if (qtyControls) qtyControls.style.display = "flex";
        if (selectBtn) selectBtn.style.display = "none";
        if (quantityDisplay) quantityDisplay.textContent = quantity.toString();
        
        const plusBtn = selector.querySelector(".bkn-starter-pack-plus");
        if (plusBtn && 'disabled' in plusBtn) {
          plusBtn.disabled = this.totalQuantity >= 7;
          plusBtn.style.opacity = this.totalQuantity >= 7 ? "0.3" : "1";
        }
      }
    },

    handleQuantityChange(e) {
      const button = e.target;
      const action = button.getAttribute("data-action");
      const productId = button.getAttribute("data-product");

      let currentQty = this.productQuantities[productId] || 0;

      if (action === "increase") {
        if (this.totalQuantity >= 7) return;
        currentQty++;
      } else if (action === "decrease" && currentQty > 0) {
        currentQty--;
      }

      this.productQuantities[productId] = currentQty;
      this.updateQuantitySelector(productId);
      this.calculateTotalQuantity();
      this.updateBagSelection();
      this.updateCartButton();
    },

    calculateTotalQuantity() {
      this.totalQuantity = Object.values(this.productQuantities).reduce((sum, qty) => sum + qty, 0);

      Object.keys(this.productQuantities).forEach((productId) => {
        this.updateQuantitySelector(productId);
      });

      const debugTotal = document.getElementById("totalQuantity");
      if (debugTotal) debugTotal.textContent = this.totalQuantity;
    },

    updateBagSelection() {
      let selectedBagCount = 3;

      if (this.totalQuantity <= 3) {
        selectedBagCount = 3;
      } else if (this.totalQuantity <= 5) {
        selectedBagCount = 5;
      } else {
        selectedBagCount = 7;
      }

      this.selectedBagCount = selectedBagCount;

      const subscribeRadio = document.getElementById("subscribe");
      const isSubscription = subscribeRadio && 'checked' in subscribeRadio && subscribeRadio.checked;
      const subscriptionValue = isSubscription ? "true" : "false";

      const selectedOption = document.querySelector(
        `[data-bag-count="${selectedBagCount}"][data-subscription="${subscriptionValue}"]`
      );
      
      if (selectedOption) {
        this.setActiveOption(selectedOption);
        
        const variantId = selectedOption.getAttribute("data-variant-id");
        if (variantId) {
          const currentUrl = new URL(window.location.href);
          const currentVariant = currentUrl.searchParams.get("variant");
          
          if (currentVariant !== variantId) {
            currentUrl.searchParams.set("variant", variantId);
            window.history.replaceState({}, "", currentUrl.toString());
            this.persistVariant(variantId, selectedBagCount, subscriptionValue);
            this.updatePriceFromActiveOption();
            this.dispatchVariantSelectedEvent(variantId, { bagCount: selectedBagCount, subscription: subscriptionValue, element: selectedOption });
          }
        }
      }

      const debugBag = document.getElementById("selectedBag");
      if (debugBag) debugBag.textContent = `${selectedBagCount} bags`;
    },

    handleBagSelection(e) {
      const clickedOption = e.target.closest(".bkn-starter-pack-bag-option");
      if (!clickedOption) return;
      
      const bagCount = parseInt(clickedOption.getAttribute("data-bag-count"));
      const subscription = clickedOption.getAttribute("data-subscription");
      const variantId = clickedOption.getAttribute("data-variant-id");
      
      this.selectedBagCount = bagCount;

      this.setActiveOption(clickedOption);

      const url = new URL(window.location.href);
      url.searchParams.set("variant", variantId);
      window.history.replaceState({}, "", url.toString());

      this.persistVariant(variantId, bagCount, subscription);
      this.updatePriceFromActiveOption();
      this.dispatchVariantSelectedEvent(variantId, { bagCount, subscription, element: clickedOption });

      this.adjustQuantitiesToBag(bagCount);
    },

    adjustQuantitiesToBag(targetBagCount) {
      const currentTotal = this.totalQuantity;

      if (currentTotal === 0) return;

      if (currentTotal < targetBagCount) {
        const difference = targetBagCount - currentTotal;
        const productIds = Object.keys(this.productQuantities);

        if (productIds.length > 0) {
          let remaining = difference;
          productIds.forEach((productId) => {
            if (remaining > 0 && this.productQuantities[productId] && this.productQuantities[productId] > 0) {
              this.productQuantities[productId]++;
              remaining--;
              this.updateQuantitySelector(productId);
            }
          });
        }
      }

      this.calculateTotalQuantity();
      this.updateCartButton();
    },

    updateCartButton() {
      const cartButtonText = document.getElementById("cartButtonText");
      const bagPrice = this.getSelectedBagPrice();
      
      const invalidQuantities = [0, 1, 2, 4, 6];
      const shouldDisable = invalidQuantities.includes(this.totalQuantity);
      
      if (this.addToCartBtn && 'disabled' in this.addToCartBtn) {
        this.addToCartBtn.disabled = shouldDisable;
      }
      if (this.addToCartBtn) {
        this.addToCartBtn.style.opacity = shouldDisable ? "0.6" : "1";
      }
      if (cartButtonText) {
        cartButtonText.textContent = `Add to Cart • ${bagPrice}`;
      }
    },

    getSelectedBagPrice() {
      const activeBagOption = document.querySelector('.bkn-starter-pack-bag-option.bkn-starter-pack-active');
      if (activeBagOption) {
        const price = activeBagOption.getAttribute('data-price');
        if (price) return price;
      }
      return '$25.99';
    },

    dispatchVariantSelectedEvent(variantId, additionalData = {}) {
      const variantSelectedEvent = new CustomEvent('variant:selected', {
        detail: {
          variantId: variantId,
          ...additionalData
        },
        bubbles: true
      });

      const container = document.querySelector('.bkn-starter-pack-container');
      if (container) container.dispatchEvent(variantSelectedEvent);

      const changeEvent = new CustomEvent('starter-pack:variant-changed', {
        detail: {
          variantId: variantId,
          ...additionalData
        },
        bubbles: true
      });
      
      document.dispatchEvent(changeEvent);
    },

    handleAddToCart(e) {
      if (this.totalQuantity === 0) {
        console.warn('No products selected');
        return;
      }

      const activeBagOption = document.querySelector('.bkn-starter-pack-bag-option.bkn-starter-pack-active');
      if (!activeBagOption) {
        console.error('No bag option selected');
        return;
      }

      const variantId = activeBagOption.getAttribute('data-variant-id');
      if (!variantId) {
        console.error('No variant ID found');
        return;
      }

      const selectedFlavors = this.getSelectedFlavors();
      const subscribeRadio = document.getElementById("subscribe");
      const isSubscription = subscribeRadio && 'checked' in subscribeRadio && subscribeRadio.checked;

      const cartData = {
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            ...selectedFlavors.reduce((acc, flavor, index) => {
              acc[`flavor_${index + 1}`] = flavor;
              return acc;
            }, {}),
            '_total_items': this.totalQuantity,
            '_bag_type': activeBagOption.querySelector('.bkn-starter-pack-bag-count')?.textContent || '',
            '_purchase_type': isSubscription ? 'subscription' : 'one-time'
          }
        }]
      };

      this.addToCart(cartData);
    },

    getSelectedFlavors() {
      const flavorCounts = {};
      
      Object.keys(this.productQuantities).forEach(productId => {
        const quantity = this.productQuantities[productId];
        if (quantity > 0) {
          const productCard = document.querySelector(`[data-product="${productId}"]`);
          if (productCard) {
            const productNameElement = productCard.closest('.bkn-starter-pack-product-card')?.querySelector('.bkn-starter-pack-product-name');
            if (productNameElement) {
              const productName = productNameElement.textContent.trim();
              flavorCounts[productName] = quantity;
            }
          }
        }
      });

      return Object.entries(flavorCounts).map(([flavor, qty]) => `${qty}x ${flavor}`);
    },

    addToCart(cartData) {
      const addToCartBtn = document.getElementById("addToCartBtn");
      const cartButtonText = document.getElementById("cartButtonText");
      
      if (addToCartBtn && 'disabled' in addToCartBtn) addToCartBtn.disabled = true;
      if (cartButtonText) cartButtonText.textContent = "ADDING TO CART...";

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cartData)
      })
      .then(response => response.ok ? response.json() : Promise.reject(new Error(`HTTP error! status: ${response.status}`)))
      .then(data => {
        this.showAddToCartSuccess();
        this.handleAddToCartSuccess(data);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        this.showAddToCartError(error);
      })
      .finally(() => {
        if (addToCartBtn && 'disabled' in addToCartBtn) addToCartBtn.disabled = false;
        if (cartButtonText) {
          const bagPrice = this.getSelectedBagPrice();
          cartButtonText.textContent = `Add to Cart • ${bagPrice}`;
        }
      });
    },

    showAddToCartSuccess() {
      const cartButtonText = document.getElementById("cartButtonText");
      if (cartButtonText) {
        cartButtonText.textContent = "ADDED TO CART!";
        setTimeout(() => {
          const bagPrice = this.getSelectedBagPrice();
          cartButtonText.textContent = `Add to Cart • ${bagPrice}`;
        }, 2000);
      }
    },

    handleAddToCartSuccess(cartResponse) {
      const activeBagOption = document.querySelector('.bkn-starter-pack-bag-option.bkn-starter-pack-active');
      const variantId = activeBagOption?.getAttribute('data-variant-id');

      const cartAddEvent = new CartAddEvent({}, variantId || 'starter-pack', {
        source: 'starter-pack',
        variantId: variantId,
        itemCount: cartResponse.item_count || 1,
        productId: variantId
      });
      
      document.dispatchEvent(cartAddEvent);

      const starterPackEvent = new CustomEvent('starter-pack:added-to-cart', {
        detail: {
          flavors: this.getSelectedFlavors(),
          totalQuantity: this.totalQuantity
        },
        bubbles: true
      });
      
      document.dispatchEvent(starterPackEvent);

      const cartDrawerComponent = document.querySelector('cart-drawer-component');
      if (cartDrawerComponent && typeof cartDrawerComponent.open === 'function') {
        cartDrawerComponent.open();
      } else {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          const cartIcon = document.querySelector('[aria-label*="cart"]') || 
                          document.querySelector('.cart-icon') ||
                          document.querySelector('[data-cart-icon]');
          if (cartIcon) cartIcon.click();
        }
      }
    },

    showAddToCartError(error) {
      const cartButtonText = document.getElementById("cartButtonText");
      if (cartButtonText) {
        cartButtonText.textContent = "ERROR - TRY AGAIN";
        setTimeout(() => {
          const bagPrice = this.getSelectedBagPrice();
          cartButtonText.textContent = `Add to Cart • ${bagPrice}`;
        }, 3000);
      }
      console.error('Add to cart failed:', error);
    }
  };

  starterPackManager.init();
});